export default "__VITE_ASSET__B_OXs3k5__"